import { Injectable } from '@angular/core';
import { AngularFireDatabase } from "@angular/fire/database";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UpdatefirebaseService {

  constructor(private firebase: AngularFireDatabase) { }

  // แก้ไขสถานะแปลง 1
  async updatePlantStatus(year: any, key: any, id: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/');
    local.update(key, { approveSts: id });
  }

  // แก้ไขประเภทอ้อย 2
  async updateCaneType(year: any, key: any, id: any, canename: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/' + key + '/');
    local.update('DetailPlant', { CaneTypeId: id, CaneTypeName: canename });
  }


  // แก้ไขเจ้าของแปลง 3
  async updateOwnerPlant(year: any, key: any, landno: any, code: any, name: any, surname: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/' + key + '/');
    local.update('bnm_profile', { code: code, name: name, surname: surname });
    const local2 = this.firebase.list('inst1/tx/' + year + '/areas/');
    local2.update(key, { landno: landno });
  }

  // แก้ไขจำนวนแปลง ของชาวไร่ 1 คน
  async updateplantnowithfmcode(key: any, count: any) {
    const runLandno = this.firebase.list('inst1/runLandno/');
    runLandno.update(key, { number: count });
  }

  // แก้ไขโซน  4
  async updateZoneplant(year: any, key: any, zone: any, landno: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/' + key + '/');
    local.update('DetailPlant', { ZoneId: zone });
    const local2 = this.firebase.list('inst1/tx/' + year + '/areas/');
    local2.update(key, { landno: landno });
  }

  // ย้ายโซน 
  async updatezoneplantno(key: any, landno: any) {
    const local2 = this.firebase.list('plant/');
    local2.update(key, { landno: landno });
  }

  // แก้ไขกรรมสิทธิ์แปลง  5
  async updatePlantSelfLand(year: any, key: any, id: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/' + key + '/');
    local.update('DetailPlant', { SelfLand: id });
  }

  // แก้ไขนักส่งเสริม  6
  async updateSupporter(year: any, key: any, codeid: any) {
    let userspv: any;
    this.getOnesupporter(codeid).then(spvdata => { userspv = spvdata; });
    setTimeout(() => {
      console.log("1s" + userspv);
    }, 1000);
    setTimeout(() => {
      console.log("2s" + userspv);
    }, 2000);
    setTimeout(() => {
      console.log("3s" + userspv);
    }, 3000);
    setTimeout(() => {
      const spv = this.firebase.list('inst1/tx/' + year + '/areas/' + key + '/');
      spv.update(key, { spv: userspv[0].key });
      const local = this.firebase.list('inst1/tx/' + year + '/areas/' + key + '/');
      local.update('spv_profile', { code: userspv[0].code, name: userspv[0].name, surname: userspv[0].surname });
      alert('อัพเดทข้อมูลเรียบร้อบแล้วค่ะ')
    }, 4000);


  }


  getOnesupporter(code: any) {
    return new Promise((res, rej) => {
      this.firebase
        .list("inst1/supporterprofile/")
        .query
        .once("value")
        .then((snapshots) => {
          let onesup: any[] = [];
          snapshots.forEach((snapshots) => {
            let rec = {
              key: snapshots.key,
              ...snapshots.val()
            }
            if ((rec.code) == code) {
              onesup.push(rec)
            }

          });
          res(onesup);
        })
        .catch((e) => {
          rej(e);
        });
    });
  }

  // สร้างชายใหม่
  async updateNewchild() {
    const local = this.firebase.list('inst1/supporterprofile/');
    local.update('key', { ZoneId: '01' });
  }

  // เพิ่มวันตัดโดยนักส่งเสริม
  async updateCutStartBySupport(key: any, year: any, date: any, date2: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/');
    local.update(key, { cutstart: date, cutstop: date2 });
  }

  // เพิ่มวันตัดอ้อยพันธุ์
  async updateCutCaneSeedStartBySupport(key: any, year: any, date: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/');
    local.update(key, { cutstart: date });
  }

  // อัพเดทกลุ่มบำรุง
  async updategrouprepair(key: any, groupcode: any, year: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas');
    local.update(key, { groupCode_m: groupcode });
  }

  // กลุ่มตัด
  async updategroupcut(key: any, groupcode: any, year: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas');
    local.update(key, { groupCode: groupcode });
  }
  // งวดตัด
  async updatePeriod_cut(key: any, period_cut: any, year: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas');
    local.update(key, { period_cut: period_cut });
  }
  // ยกเลิกวันตัดเสร็จ
  async Deletecutstop(key: any, year: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas/' + key);
    local.remove("cutstop");
  }

  // updateMap
  async updateAreas(year: any, key: any, item: any) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas');
    local.update(key, item);
  }
  // อัพเดท_areas
  async updateareas(year, key, item) {
    const local = this.firebase.list('inst1/tx/' + year + '/areas');
    local.update(key, item);
  }

}
